/* tslint:disable */
/* eslint-disable */
// Generated by Microsoft Kiota
// @ts-ignore
import { createComplianceReminderFromDiscriminatorValue, createProblemDetailsFromDiscriminatorValue, serializeSendCustomerComplianceReminderCommand, type ComplianceReminder, type ProblemDetails, type SendCustomerComplianceReminderCommand } from '../../../../models/index.js';
// @ts-ignore
import { type BaseRequestBuilder, type Parsable, type ParsableFactory, type RequestConfiguration, type RequestInformation, type RequestsMetadata } from '@microsoft/kiota-abstractions';

/**
 * Builds and executes requests for operations under /customers/{customer-id}/messages/compliance-reminder
 */
export interface ComplianceReminderRequestBuilder extends BaseRequestBuilder<ComplianceReminderRequestBuilder> {
    /**
     * GetCustomerComplianceReminder
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {Promise<ComplianceReminder>}
     * @throws {ProblemDetails} error when the service returns a 400 status code
     * @throws {ProblemDetails} error when the service returns a 404 status code
     * @throws {ProblemDetails} error when the service returns a 409 status code
     */
     get(requestConfiguration?: RequestConfiguration<object> | undefined) : Promise<ComplianceReminder | undefined>;
    /**
     * SendCustomerComplianceReminder
     * @param body The request body
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @throws {ProblemDetails} error when the service returns a 400 status code
     * @throws {ProblemDetails} error when the service returns a 404 status code
     * @throws {ProblemDetails} error when the service returns a 409 status code
     */
     post(body: SendCustomerComplianceReminderCommand, requestConfiguration?: RequestConfiguration<object> | undefined) : Promise<void>;
    /**
     * GetCustomerComplianceReminder
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {RequestInformation}
     */
     toGetRequestInformation(requestConfiguration?: RequestConfiguration<object> | undefined) : RequestInformation;
    /**
     * SendCustomerComplianceReminder
     * @param body The request body
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {RequestInformation}
     */
     toPostRequestInformation(body: SendCustomerComplianceReminderCommand, requestConfiguration?: RequestConfiguration<object> | undefined) : RequestInformation;
}
/**
 * Uri template for the request builder.
 */
export const ComplianceReminderRequestBuilderUriTemplate = "{+baseurl}/customers/{customer%2Did}/messages/compliance-reminder";
/**
 * Metadata for all the requests in the request builder.
 */
export const ComplianceReminderRequestBuilderRequestsMetadata: RequestsMetadata = {
    get: {
        uriTemplate: ComplianceReminderRequestBuilderUriTemplate,
        responseBodyContentType: "application/json",
        errorMappings: {
            400: createProblemDetailsFromDiscriminatorValue as ParsableFactory<Parsable>,
            404: createProblemDetailsFromDiscriminatorValue as ParsableFactory<Parsable>,
            409: createProblemDetailsFromDiscriminatorValue as ParsableFactory<Parsable>,
        },
        adapterMethodName: "send",
        responseBodyFactory:  createComplianceReminderFromDiscriminatorValue,
    },
    post: {
        uriTemplate: ComplianceReminderRequestBuilderUriTemplate,
        responseBodyContentType: "application/problem+json",
        errorMappings: {
            400: createProblemDetailsFromDiscriminatorValue as ParsableFactory<Parsable>,
            404: createProblemDetailsFromDiscriminatorValue as ParsableFactory<Parsable>,
            409: createProblemDetailsFromDiscriminatorValue as ParsableFactory<Parsable>,
        },
        adapterMethodName: "sendNoResponseContent",
        requestBodyContentType: "application/json",
        requestBodySerializer: serializeSendCustomerComplianceReminderCommand,
        requestInformationContentSetMethod: "setContentFromParsable",
    },
};
/* tslint:enable */
/* eslint-enable */
